module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Ruller-9639057de3693481d0018cdf9f81fcb3.svg";